import { ReactNode, createContext, useCallback, useContext, useState } from 'react'

interface SideMenuContextProps {
  isSideMenuOpen: boolean
  toggleSideMenu: () => void
}

interface SideMenuProviderProps {
  children: ReactNode
}

const SideMenuContext = createContext<SideMenuContextProps | undefined>(undefined)

function SideMenuProvider ({ children }: SideMenuProviderProps): React.ReactElement {
  const [isSideMenuOpen, setIsSideMenuOpen] = useState<boolean>(() =>
    !(window.matchMedia('(max-width: 760px)').matches && window.location.pathname.startsWith('/rastreabilidade')))

  const toggleSideMenu = useCallback(() => {
    setIsSideMenuOpen(prevState => !prevState)
    !isSideMenuOpen ? document.body.style.overflow = 'hidden' : document.body.style.overflow = 'auto'
  }, [isSideMenuOpen])

  return <SideMenuContext.Provider value={{ isSideMenuOpen, toggleSideMenu }}>
        {children}
    </SideMenuContext.Provider>
};

export const useSideMenu = (): SideMenuContextProps => {
  const context = useContext(SideMenuContext)
  if (!context) {
    throw new Error('useSideMenu must be used within a MenuProvider')
  }
  return context
}

export default SideMenuProvider
